export const isPartnerReferral = (params?: Record<string, string>): boolean => {
  const utmCampaign = params?.utm_campaign;
  const utmMedium = params?.utm_medium;

  return utmCampaign === 'partner_feed' && utmMedium === 'referral';
};

export const isSofiPartnerReferralFromParams = (params?: Record<string, string>): boolean =>
  !!(params?.utm_source === 'sofi.com' && isPartnerReferral(params));

export const isSofiPartnerReferral = (params?: Record<string, string>): boolean => {
  const isSofiUtm = params?.utm_source === 'sofi.com' && isPartnerReferral(params);
  const isSofiReferrer = typeof document !== 'undefined' && document.referrer?.includes('sofi.com');
  return isSofiUtm || isSofiReferrer;
};

export const isRobinhoodPartnerReferralFromParams = (params?: Record<string, string>): boolean =>
  !!(params?.utm_source === 'robinhood.com' && isPartnerReferral(params));

export const isRobinhoodPartnerReferral = (params?: Record<string, string>): boolean => {
  const isRobinhoodUtm = params?.utm_source === 'robinhood.com' && isPartnerReferral(params);
  const isRobinhoodReferrer = typeof document !== 'undefined' && document.referrer?.includes('robinhood.com');
  return isRobinhoodUtm || isRobinhoodReferrer;
};
